module.exports = __webpack_public_path__ + "arrow-down.00677556dbe5800ec465.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/arrow-down.svg
// module id = ../../../../../src/img/icon/arrow-down.svg
// module chunks = styles